import React from "react";
import { SecondaryText } from "../../styles/global";

const skills_icon = [
  {
    image: "assest/icons/skills_icon/js.png",
    name: "JavaScript",
  },
  {
    image: "assest/icons/skills_icon/typescript.png",
    name: "TypeScript",
  },
  {
    image: "assest/icons/skills_icon/nextjs.png",
    name: "Next Js",
  },
  {
    image: "assest/icons/skills_icon/react.png",
    name: "React Js",
  },
  {
    image: "assest/icons/skills_icon/react-native.png",
    name: "React Native",
  },
  {
    image: "assest/icons/skills_icon/redux.png",
    name: "Redux",
  },
  {
    image: "assest/icons/skills_icon/nodejs.png",
    name: "Node Js",
  },
  {
    image: "assest/icons/skills_icon/express.png",
    name: "Express Js",
  },
  {
    image: "assest/icons/skills_icon/mongodb.png",
    name: "Mongo DB",
  },
  {
    image: "assest/icons/skills_icon/sass.png",
    name: "SCSS",
  },
  {
    image: "assest/icons/skills_icon/html.png",
    name: "HTML",
  },
  {
    image: "assest/icons/skills_icon/css.png",
    name: "CSS",
  },
  {
    image: "assest/icons/skills_icon/python.png",
    name: "Python",
  },
  {
    image: "assest/icons/skills_icon/scikit.png",
    name: "Scikit Learn",
  },
  {
    image: "assest/icons/skills_icon/numpy.png",
    name: "Numpy",
  },
  {
    image: "assest/icons/skills_icon/pandas.png",
    name: "Pandas",
  },
];

const SkillCard = () => {
  return (
    <div className="grid grid-cols-3  md:grid-cols-4 items-center gap-10">
      {skills_icon.map((skill, index) => {
        return (
          <div
            className="  flex items-center justify-center flex-col"
            key={index}
          >
            <img src={skill.image} alt={skill.name} />
            <SecondaryText className="text-center mt-2">
              {skill.name}
            </SecondaryText>
          </div>
        );
      })}
    </div>
  );
};

export default SkillCard;
